module.exports = __webpack_public_path__ + "img/background.6b477c06.png";